var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsSleepFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-sleep-filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-sleep-filled",
    stroke: "#7F8BDB"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "15.5 0.501 18.5 0.501 15.5 3.501 18.5 3.501"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "18.5 6.501 23.5 6.501 18.5 11.501 23.5 11.501"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,13.5000001 C14,10.1862915 11.3137085,7.50000009 8,7.50000009 C4.68629154,7.50000009 2,10.1862915 2,13.5000001 L2,19.0000001 C2,19.8284271 1.32842712,20.5000001 0.5,20.5000001 L15.5,20.5000001 C14.6715729,20.5000001 14,19.8284271 14,19.0000001 L14,13.5000001 Z",
    id: "Path",
    fill: "#7F8BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.415,22.5 C9.20334711,23.0997387 8.63649013,23.5008109 8.0005,23.5008109 C7.36450987,23.5008109 6.79765289,23.0997387 6.586,22.5",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 5.501,
    x2: 8,
    y2: 7.501,
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSleepFilled);
export default __webpack_public_path__ + "static/media/icons-sleep-filled.272b3e877cd8816a25c60ff46c594a09.svg";
export { ForwardRef as ReactComponent };